export default {
      id: "arrow_up-usage",
      viewBox: "0 0 10 12",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#arrow_up",
      toString: function () {
        return this.url;
      }
    }